import React from 'react'

import Layer from './Layer'

export default React.createClass({
  propTypes: {
    data: React.PropTypes.array.isRequired,
    settings: React.PropTypes.object.isRequired,
    onRedraw: React.PropTypes.func
  },
  getInitialState() {
    // TODO: this is a hack to refresh state
    // after initial rendering happened
    setTimeout(this.handleResize, 100);

    return {
      isLoading: true,
      width: 0,
      height: 0
    }
  },
  componentDidMount: function() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  componentWillUnmount: function() {
    window.removeEventListener('resize', this.handleResize);
  },
  render() {
    return (
      <svg ref="canvas" className="artboard flex-fill">
        <Layer {...this.props} x={0} y={0} onRedraw={this.props.onRedraw}
               width={this.state.width} height={this.state.height} />
      </svg>
    )
  },
  handleResize: function(e) {
    let w = this.refs.canvas.width.baseVal.value;
    let h = this.refs.canvas.height.baseVal.value;

    this.setState({
      isLoading: w === 0 || h === 0,
      width: w,
      height: h
    });
  }
})



/** WEBPACK FOOTER **
 ** ./src/components/Artboard.js
 **/